import React, { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import { Float } from '@react-three/drei';

export default function DistantMoons() {
  const groupRef = useRef();

  // Generate 8 subtle distant dwarf planets & moons
  const moons = useMemo(() => [
    { pos: [-22, 14, 40], radius: 0.8, color: '#94a3b8', emissive: '#38bdf8', speed: 0.04 },
    { pos: [24, -12, 15], radius: 1.2, color: '#d97706', emissive: '#f59e0b', speed: 0.03 },
    { pos: [-28, -15, -15], radius: 1.5, color: '#6366f1', emissive: '#818cf8', speed: 0.05 },
    { pos: [26, 18, -45], radius: 0.9, color: '#059669', emissive: '#34d399', speed: 0.02 },
    { pos: [-20, 16, -75], radius: 1.1, color: '#e11d48', emissive: '#fb7185', speed: 0.04 },
    { pos: [22, -14, -105], radius: 1.3, color: '#7c3aed', emissive: '#c084fc', speed: 0.03 },
  ], []);

  useFrame((_, delta) => {
    if (groupRef.current) {
      groupRef.current.rotation.y += delta * 0.01;
    }
  });

  return (
    <group ref={groupRef}>
      {moons.map((m, idx) => (
        <Float key={idx} speed={1} rotationIntensity={0.2} floatIntensity={0.4}>
          <group position={m.pos}>
            <mesh>
              <sphereGeometry args={[m.radius, 32, 32]} />
              <meshStandardMaterial
                color={m.color}
                emissive={m.emissive}
                emissiveIntensity={0.25}
                roughness={0.8}
                metalness={0.2}
              />
            </mesh>
            {/* Subtle soft rim glow */}
            <mesh>
              <sphereGeometry args={[m.radius * 1.08, 16, 16]} />
              <meshBasicMaterial
                color={m.emissive}
                transparent
                opacity={0.12}
                depthWrite={false}
              />
            </mesh>
          </group>
        </Float>
      ))}
    </group>
  );
}
